import classNames from "classnames";
import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import {
  Button,
  Modal,
  Notification,
  Panel,
  toaster,
  Tooltip,
  Whisper,
} from "rsuite";
import { ModuleContext, UserContext } from "../../components/authProvider/main";
import { ErrorPopover } from "../../components/errorPopover/main";
import Formalize from "../../components/Formalize";
import axios from "../../utilities/axios";

import PlaceholderParagraph from "rsuite/esm/Placeholder/PlaceholderParagraph";
import { ConfirmModal } from "../../components/confirmModal/ConfirmModal";
import { Permission } from "../../components/Permission";
import { ParametersGlobals } from "../../core/parametersGlobals/ParametersGlobals";
import iziToast from "izitoast";

class EditPage extends React.Component<any, {}> {
  static contextType = ModuleContext;

  public state: any = {
    form: {},
    errors: {},
    values: {},
    isModalOpen: false,
    isDebugModalOpen: false,
    modalMessage: "",
    isLoading: true,
    canBlock: true,
    isFormDirty: false,
    cache: {},
    isConfirmModalOpen: false,
    isSubmitted: false,
    mountedValues: {},
    id:
      this.props.match.params.id !== undefined
        ? this.props.match.params.id
        : null,
    lastSearch: "",
  };

  public _isMounted = false;
  public crud = this.props.match.params.crud;
  public isEdit =
    this.props.view === true
      ? false
      : this.props.match.params.id
        ? true
        : false;
  public id =
    this.props.match.params.id !== undefined
      ? this.props.match.params.id
      : null;

  public listener: any = null;
  public location: any = null;

  public saveCallbacks: {
    error: Function;
    success: Function;
    type: "callback";
  }[] = [];

  public addCallback = (
    callbackMethod: Function,
    errorCallbackMethod: Function = () => { }
  ) => {
    this.saveCallbacks.push({
      success: callbackMethod,
      error: errorCallbackMethod,
      type: "callback",
    });
    return this.saveCallbacks.length - 1;
  };
  public executeSaveCallbacks = (values: any) => {
    this.saveCallbacks.forEach((callback) => {
      if (
        typeof callback === "object" &&
        callback.type === "callback" &&
        typeof callback.success === "function"
      ) {
        callback.success(values);
      }
    });
    this.saveCallbacks = [];
  };
  public executeErrorSaveCallbacks = (values: any) => {
    this.saveCallbacks.forEach((callback) => {
      if (
        typeof callback === "object" &&
        callback.type === "callback" &&
        typeof callback.error === "function"
      ) {
        callback.error(values);
      }
    });
    this.saveCallbacks = [];
  };

  componentDidMount() {
    this._isMounted = true;

    this.setState({
      lastSearch: localStorage.getItem("searchHistoric"),
    });
    window.onbeforeunload = (event) => {
      if (this.state.isFormDirty === true) {
        event.preventDefault();
      }
    };
    this.listener = this.props.history.block((location: any) => {
      if (this.state.canBlock === true && this.state.isFormDirty === true) {
        if (location.pathname !== this.props.history.location.pathname) {
          if (location.search.includes("force=true")) {
            return true;
          }
          if (
            !this.state.isSubmitted &&
            this.state.isConfirmModalOpen === false
          ) {
            this.setState({ isConfirmModalOpen: true });
            if (location.pathname) {
              this.location = location.pathname;
            }

            return false;
          }
        }
      }
      return true;
    });
    this.loadfields();
  }

  componentWillUnmount() {
    this.listener();
    this._isMounted = false;
    window.onbeforeunload = (event) => { };
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.currentValues = {};
      this.crud = this.props.match.params.crud;
      this.isEdit =
        this.props.view === true
          ? false
          : this.props.match.params.id
            ? true
            : false;
      this.id =
        this.props.match.params.id !== undefined
          ? this.props.match.params.id
          : null;
      this.setState(
        {
          form: {},
          errors: {},
          values: {},
          isModalOpen: false,
          isDebugModalOpen: false,
          modalMessage: "",
          isLoading: true,
          canBlock: true,
          isFormDirty: false,
          cache: {},
          isConfirmModalOpen: false,
          mountedValues: {},
          id:
            this.props.match.params.id !== undefined
              ? this.props.match.params.id
              : null,
        },
        () => {
          this.loadfields();
        }
      );
    }
  }

  loadfields = () => {
    axios
      .get("/api/v1/" + this.crud + "/fields")
      .then((res) => {
        if (res.data && res.data.fields) {
          if (this._isMounted) {
            var stateObj = { form: res.data.fields, isLoading: true };

            if (this.isEdit || this.props.view === true) {
              this.loadModelData(res.data.fields);
            } else {
              stateObj.isLoading = false;
            }

            this.setState(stateObj);
          }
        }
      })
      .finally(() => {
        this._isMounted = true;
      });
  };

  loadModelData = (fields: any) => {
    axios.get("/api/v1/" + this.crud + "/" + this.id).then((res) => {
      if (res.data && res.data.item) {
        this.setState({
          id: this.id,
          mountedValues: res.data.item,
          values: res.data.item,
          isLoading: false,
        });
      }
    });
  };

  public currentValues = {};
  public guid: string | null = null;

  onSubmit = (
    values: any,
    guid: string | null = null,
    cache: any = null,
    shouldContinue: boolean = false
  ) => {
    var url = "/api/v1/" + this.crud + "/" + (this.isEdit ? this.id : "add");
    const primaryKey = this.state.form.$GLOBALS.prefix + "_id";

    if (guid) {
      this.guid = guid;
    }
    if (shouldContinue && guid === null) {
      guid = this.guid;
    }
    this.currentValues = values;
    this.setState({ isLoading: true, values, cache });
    for (var fieldName in values) {
      var value = values[fieldName];
      if (value) {
        if (fieldName === "guid") {
        } else {
          if (
            this.state.form[fieldName] &&
            this.state.form[fieldName].type === "select"
          ) {
            if (typeof value === "object") {
              if (value["label"] && value["value"]) {
                values[fieldName] = value["value"];
              }
            }
          }
        }
      }
    }
    var output = { ...values, guid };

    var loadedValues = this.state.mountedValues;

    axios
      .post(url, {
        data: output,
        loadedValues,
        continue: shouldContinue === true ? true : undefined,
      })
      .then((res) => {
        this.setState({ canBlock: false, isLoading: false });
        this.listener = this.props.history.block((location: any) => {
          return false;
        });
        this.listener();

        iziToast.success({
          title: "Sucesso!",
          message: `Registro ${this.isEdit ? "atualizado" : "cadastrado"} com sucesso!`,
          position: "topRight",
          close: true,
        });


        if (
          res.data.result &&
          res.data.result[0] &&
          res.data.result[0][primaryKey]
        ) {
          if (this.saveCallbacks?.length > 0) {
            this.executeSaveCallbacks(res.data.result[0]);
          }

          this.props.history.push(
            "/dashboard/" + (this.context as any).name + "/" + this.crud
          );

          this.isEdit = true;
          this.id = res.data.result[0][primaryKey];
          this.loadfields();
        } else {
          if (this.saveCallbacks?.length > 0) {
            this.executeSaveCallbacks(res.data.result[0]);
          }

          this.props.history.push(
            "/dashboard/" + (this.context as any).name + "/" + this.crud
          );
        }
      })
      .finally(() => {
        // Removido o estado de "isLoading: false" daqui, já está definido após o sucesso
      })
      .catch((e) => {
        this.setState({ isLoading: false }); // Garanta que isLoading seja desativado em erros
        this.executeErrorSaveCallbacks({ ...values, guid });
        if (e?.response?.status) {
          if (e.response.status === 406) {
            console.log("Error response :::: ", e.response.data);
            if (e.response.data?.errors) {
              this.setState({ errors: e.response.data.errors });
            }
            if (e.response.data.messages) {
              for (var i in e.response.data.messages) {
                iziToast.error({
                  title: "Erro!",
                  message: e.response.data.messages[i],
                  position: "topRight",
                  timeout: 5000,
                  close: true,
                });
              }
            }
          }
          if (e.response.status === 403) {
            for (var errorIndex in e.response.data.errors) {
              iziToast.error({
                title: "Erro!",
                message: e.response.data.errors[errorIndex],
                position: "topRight",
                timeout: 10000,
                close: true,
              });

            }
          }
          if (e.response.status === 409) {
            this.setState({
              isModalOpen: true,
              modalMessage:
                "Houve uma alteração nesse registro enquanto você alterava, deseja mesmo continuar com a alteração ?",
            });
            this.listener = null;
          }
        } else {
          throw e;
        }
      });
    this.listener = null;
  };

  onConfirm = () => {
    if (typeof this.listener === "function") {
      this.listener();
    }
    this.props.history.push(`${this.location}${this.state.lastSearch}`);
    window.location.reload();
  };


  onCancel = () => {
    this.setState({ isConfirmModalOpen: false });
  };

  onClickDebug = () => {
    this.setState({ isDebugModalOpen: true });
  };

  onCloseDebug = () => {
    this.setState({ isLoading: true }, () => {
      this.setState({ isDebugModalOpen: false, isLoading: false });
    });
  };

  onBack = () => {
    this.props.history.push(
      `/dashboard/${(this.context as any).name}/${this.crud}${this.state.lastSearch}`
    );
  };

  renderTitleName = () => {
    var GLOBALS = this.state.form["$GLOBALS"]
      ? this.state.form["$GLOBALS"]
      : { icon: null, singular_name: null };
    var numberExibtion: any = this.state.id;
    if (this.state.values.psm_os_number) {
      numberExibtion = this.state.values.psm_os_number;
    }
    if (this.state.values.box_romanian) {
      numberExibtion = this.state.values.box_romanian;
    }
    if (this.isEdit) {
      return (
        <>
          Editando{" "}
          {GLOBALS.singular_name ? (
            GLOBALS.singular_name
          ) : (
            <ErrorPopover title="Missing singular/plural name">
              {this.crud}
            </ErrorPopover>
          )}{" "}
          #{numberExibtion}
        </>
      );
    } else {
      if (this.props.view) {
        return (
          <>
            Visualizando{" "}
            {GLOBALS.singular_name ? (
              GLOBALS.singular_name
            ) : (
              <ErrorPopover title="Missing singular/plural name">
                {this.crud}
              </ErrorPopover>
            )}{" "}
            #{numberExibtion}
          </>
        );
      } else {
        return (
          <>
            Cadastro de{" "}
            {GLOBALS.plural_name ? (
              GLOBALS.plural_name
            ) : (
              <ErrorPopover title="Missing singular/plural name">
                {this.crud}
              </ErrorPopover>
            )}
          </>
        );
      }
    }
  };

  render() {
    var GLOBALS = this.state.form["$GLOBALS"]
      ? this.state.form["$GLOBALS"]
      : { icon: null, singular_name: null };
    return (
      <>
        <div
          style={{
            zIndex: 1,
            marginLeft:
              localStorage.getItem("hiddenSidebar") === "true"
                ? "0px"
                : "203px",
          }}
          className="container"
        >
          <Helmet>
            <title>
              {`${ParametersGlobals.projectTitle}`}
              {this.state.form?.$GLOBALS?.singular_name
                ? "- Cadastro de " + this.state.form?.$GLOBALS?.singular_name
                : this.crud}
            </title>
          </Helmet>

          <Modal open={this.state.isModalOpen} size={"sm"} className="centered">
            <Modal.Header>
              <Modal.Title>
                <i
                  className="fas fa-fw mr-2 fa-exclamation-triangle"
                  style={{ color: "#ffb300", fontSize: 24 }}
                ></i>
                Atenção!
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.state.modalMessage}</Modal.Body>
            <Modal.Footer>
              <Button
                appearance="primary"
                onClick={() =>
                  this.onSubmit(this.currentValues, null, null, true)
                }
              >
                Confirmar
              </Button>
              <Button
                color="red"
                onClick={() => this.setState({ isModalOpen: false })}
              >
                Cancelar
              </Button>
            </Modal.Footer>
          </Modal>

          <Panel bordered className="rs-no-body mb-4 w-100">
            <div className="d-flex justify-contents-between align-items-center">
              <div></div>
              <div>
                <h5 className="d-flex align-items-center">
                  <i
                    className={classNames(
                      "fas",
                      "fa-fw mr-4",
                      "fa-" + GLOBALS.icon
                    )}
                  ></i>
                  {this.renderTitleName()}
                </h5>
              </div>
              <div>
                <UserContext.Consumer>
                  {(user: any) => {
                    if (user.data?.user_fk_role_id === 2) {
                      return (
                        <Whisper
                          trigger="hover"
                          placement="bottom"
                          speaker={<Tooltip placement="bottom">DEBUG</Tooltip>}
                        >
                          <Button
                            onClick={this.onClickDebug}
                            className="mr-2"
                            color={"violet"}
                          >
                            <i className="fas fa-fw fa-bug"></i>
                          </Button>
                        </Whisper>
                      );
                    }
                    return null;
                  }}
                </UserContext.Consumer>
                {this.crud !== "checklist_parameters" &&
                  this.props.name !== "filled_checklists" && (
                    <Permission name={this.props.match.params.crud + "-add"}>
                      <Whisper
                        trigger="hover"
                        placement="bottom"
                        speaker={
                          <Tooltip placement="bottom">Adicionar</Tooltip>
                        }
                      >
                        <Button
                          color={"green"}
                          onClick={() =>
                            this.props.history.push(
                              "/dashboard/" +
                              (this.context as any).name +
                              "/" +
                              this.crud +
                              "/add"
                            )
                          }
                        >
                          <i className="fas fa-fw fa-plus"></i>
                        </Button>
                      </Whisper>
                    </Permission>
                  )}
                <Whisper
                  trigger="hover"
                  placement="bottom"
                  speaker={<Tooltip placement="bottom">Voltar</Tooltip>}
                >
                  <Button
                    className="ml-2"
                    color={"blue"}
                    onClick={() => this.onBack()}
                  >
                    <i className="fas fa-fw fa-angle-left"></i>
                  </Button>
                </Whisper>
              </div>
            </div>
          </Panel>

          {this.state.isLoading === false && (
            <UserContext.Consumer>
              {(user) => {
                return (
                  <Formalize
                    addCallback={this.addCallback}
                    onDirty={(name: string) => {
                      this.setState({ isFormDirty: true });
                    }}
                    cache={this.state.cache}
                    history={this.props.history}
                    match={this.props.match}
                    readOnly={this.props.view === true}
                    isEdit={this.isEdit}
                    values={this.state.values}
                    errors={this.state.errors}
                    onSubmit={this.onSubmit}
                    form={this.state.form}
                    userContext={user}
                  />
                );
              }}
            </UserContext.Consumer>
          )}
          { }
          {this.state.isLoading === true && (
            <Panel bordered className="rs-no-body mb-4 w-100">
              <PlaceholderParagraph rows={15} />
            </Panel>
          )}

          <Modal
            size={"lg"}
            overflow={false}
            open={this.state.isDebugModalOpen}
          >
            <Modal.Header
              onClose={() => this.setState({ isDebugModalOpen: false })}
            >
              Editor DEBUG
            </Modal.Header>
            <Modal.Body>{ }</Modal.Body>
            <Modal.Footer>
              <Button color="green" onClick={this.onCloseDebug}>
                <i className="fas fa-fw fa-check"></i> Confirmar
              </Button>
              <Button
                color="red"
                onClick={() => this.setState({ isDebugModalOpen: false })}
              >
                <i className="fas fa-fw fa-times"></i> Cancelar
              </Button>
            </Modal.Footer>
          </Modal>
          <ConfirmModal
            onCancel={this.onCancel}
            onConfirm={this.onConfirm}
            show={this.state.isConfirmModalOpen}
          />
        </div>
      </>
    );
  }
}

export default withRouter(EditPage);
